import { Link } from 'react-router-dom';
import { useLang } from '../i18n';

/**
 * Booking consent block (spec §12):
 * - Terms acceptance: REQUIRED, standalone
 * - Cancellation acknowledgement: required when applicable (showCancellation)
 * - Marketing: optional, never bundled with Terms
 */
export const ConsentCheckboxes = ({ value, onChange, showCancellation = false, testid = 'consent' }) => {
  const { t } = useLang();
  const set = (k, v) => onChange({ ...value, [k]: v });
  const box = 'mt-0.5 h-4 w-4 shrink-0 accent-eco-green';
  const lbl = 'flex items-start gap-2.5 text-xs leading-relaxed text-eco-ink/70';
  return (
    <div data-testid={testid} className="space-y-2.5 rounded-xl border border-eco-ink/10 bg-eco-cream p-4">
      <label className={lbl}>
        <input type="checkbox" className={box} data-testid={`${testid}-terms`} checked={!!value.terms} onChange={(e) => set('terms', e.target.checked)} />
        <span>{t('consent.terms.pre')} <Link to="/terms" target="_blank" data-testid={`${testid}-terms-link`} className="font-semibold text-eco-green hover:underline">{t('foot.leg.terms')}</Link>. <span className="text-eco-ink/40">({t('consent.required')})</span></span>
      </label>
      {showCancellation && (
        <label className={lbl}>
          <input type="checkbox" className={box} data-testid={`${testid}-cancellation`} checked={!!value.cancellation} onChange={(e) => set('cancellation', e.target.checked)} />
          <span>{t('consent.cancellation.pre')} <Link to="/cancellation-policy" target="_blank" data-testid={`${testid}-cancellation-link`} className="font-semibold text-eco-green hover:underline">{t('foot.leg.cancellation')}</Link>.</span>
        </label>
      )}
      <label className={lbl}>
        <input type="checkbox" className={box} data-testid={`${testid}-marketing`} checked={!!value.marketing} onChange={(e) => set('marketing', e.target.checked)} />
        <span>{t('consent.marketing')} <span className="text-eco-ink/40">({t('consent.optional')})</span></span>
      </label>
    </div>
  );
};
